import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

const {
	colors,
	common: { truncate },
	spacing,
} = THEME;
const { pill } = colors;

export const pillStyles = StyleSheet.create({
	closeIcon: {
		marginLeft: 4,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		fontFamily: 'Sora',
		width: 'fit-content',
		fontSize: 14,
		gap: spacing.xs,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		position: 'relative',
	},
	label: {
		...truncate,
	},
	labelButton: {
		fontSize: 'inherit',
		backgroundColor: 'inherit',
		color: 'inherit',
		display: 'flex',
		alignItems: 'center',
		textWrap: 'none',
		gap: spacing.sm,
		':after': {
			position: 'absolute',
			content: '""',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			zIndex: 1,
		},
	},
	leftPaddingOverride: {
		paddingLeft: spacing.sm,
	},
	rightPaddingOverride: {
		paddingRight: spacing.sm,
	},
	smallFont: {
		fontSize: 12,
	},
	mediumFont: {
		fontSize: 14,
	},
});

const clickableStates = {
	':hover': {
		boxShadow: `1px 1px 2px 1px ${colors.background.dark}`,
	},
	':active': {
		backgroundColor: `var(--color-pill-active-background)`,
	},
	':disabled': {
		opacity: 0.5,
		cursor: 'not-allowed',
	},
};

const tagStyles = {
	padding: `${spacing.xs}px ${spacing.md}px`,
	borderRadius: 18,
	color: colors.text.dark,
	'--color-pill-active-background': 'var(--color-pill-gray-background)',
};

const categoryStyles = {
	...tagStyles,
	borderStyle: 'solid',
	borderWidth: 1,
	backgroundColor: colors.background.light,
	'--color-pill-active-background': 'var(--color-pill-gray-background)',
} as CSSProperties;

const labelStyles = {
	padding: `${spacing.xs}px ${spacing.md}px`,
	borderRadius: 4,
	borderStyle: 'solid',
	borderWidth: 1,
} as CSSProperties;

export const variantStyles = {
	category: {
		gray: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.gray.border,
				'--color-pill-active-background': pill.gray.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.gray.icon,
			},
		}),
		blue: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.blue.border,
				'--color-pill-active-background': pill.blue.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.blue.icon,
			},
		}),
		teal: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.teal.border,
				'--color-pill-active-background': pill.teal.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.teal.icon,
			},
		}),
		green: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.green.border,
				'--color-pill-active-background': pill.green.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.green.icon,
			},
		}),
		yellow: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.yellow.border,
				'--color-pill-active-background': pill.yellow.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.yellow.icon,
			},
		}),
		orange: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.orange.border,
				'--color-pill-active-background': pill.orange.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.orange.icon,
			},
		}),
		red: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.red.border,
				'--color-pill-active-background': pill.red.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.red.icon,
			},
		}),
		pink: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.pink.border,
				'--color-pill-active-background': pill.pink.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.pink.icon,
			},
		}),
		purple: StyleSheet.create({
			container: {
				...categoryStyles,
				borderColor: pill.purple.border,
				'--color-pill-active-background': pill.purple.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.purple.icon,
			},
		}),
	},
	tag: {
		gray: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.gray.background,
				'--color-pill-active-background': pill.gray.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.gray.icon,
			},
		}),
		blue: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.blue.background,
				'--color-pill-active-background': pill.blue.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.blue.icon,
			},
		}),
		teal: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.teal.background,
				'--color-pill-active-background': pill.teal.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.teal.icon,
			},
		}),
		green: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.green.background,
				'--color-pill-active-background': pill.green.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.green.icon,
			},
		}),
		yellow: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.yellow.background,
				'--color-pill-active-background': pill.yellow.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.yellow.icon,
			},
		}),
		orange: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.orange.background,
				'--color-pill-active-background': pill.orange.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.orange.icon,
			},
		}),
		red: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.red.background,
				'--color-pill-active-background': pill.red.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.red.icon,
			},
		}),
		pink: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.pink.background,
				'--color-pill-active-background': pill.pink.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.pink.icon,
			},
		}),
		purple: StyleSheet.create({
			container: {
				...tagStyles,
				backgroundColor: pill.purple.background,
				'--color-pill-active-background': pill.purple.background,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.purple.icon,
			},
		}),
	},
	label: {
		gray: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.gray.background,
				borderColor: pill.gray.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.gray.icon,
			},
		}),
		blue: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.blue.background,
				borderColor: pill.blue.border,
			},
			clickable: {
				':hover': {
					boxShadow: `1px 1px 2px 1px ${colors.background.dark}`,
				},
				':active': {
					backgroundColor: colors.secondary.light,
				},
				':disabled': {
					opacity: 0.8,
					cursor: 'not-allowed',
				},
			},
			icon: {
				color: pill.blue.icon,
			},
		}),
		teal: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.teal.background,
				borderColor: pill.teal.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.teal.icon,
			},
		}),
		green: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.green.background,
				borderColor: pill.green.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.green.icon,
			},
		}),
		yellow: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.yellow.background,
				borderColor: pill.yellow.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.yellow.icon,
			},
		}),
		orange: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.orange.background,
				borderColor: pill.orange.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.orange.icon,
			},
		}),
		red: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.red.background,
				borderColor: pill.red.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.red.icon,
			},
		}),
		pink: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.pink.background,
				borderColor: pill.pink.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.pink.icon,
			},
		}),
		purple: StyleSheet.create({
			container: {
				...labelStyles,
				backgroundColor: pill.purple.background,
				borderColor: pill.purple.border,
			},
			clickable: {
				...clickableStates,
			},
			icon: {
				color: pill.purple.icon,
			},
		}),
	},
	keyword: StyleSheet.create({
		container: {
			borderRadius: 6,
			color: colors.text.dark,
			padding: '4px 8px',
			backgroundColor: pill.pink.background,
		},
		clickable: {
			':hover': {
				boxShadow: `1px 1px 2px 1px ${colors.background.dark}`,
			},
			':active': {
				backgroundColor: colors.secondary.light,
			},
		},
		icon: {
			color: pill.pink.icon,
		},
	}),
};
